// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__P0QZ1","highlight":"styles_highlight__ngoY4","icon":"styles_icon__rh48H","title":"styles_title__ydF1H","count":"styles_count__ZOVgm"};